import { Injectable } from '@angular/core';

@Injectable()
export class CursorService {
  private _cursor: string = null;

  constructor() { }

  get cursor(): string {
    return this._cursor;
  }
    
  set cursor(cursor: string) {
    this._cursor = cursor;
  }
}



// WEBPACK FOOTER //
// ./src/app/cursor.service.ts